
  import { defineComponent } from 'vue';
  import { Tooltip } from '@/ui/components/Tooltip';

  interface CommentButtonProps {
    containsNotes: boolean;
    classes: string | Record<string, boolean>;
  }

  export default defineComponent<CommentButtonProps>({
    components: {
      Tooltip,
    },
    props: ['containsNotes', 'classes'],
    emits: ['click'],
  });
